import { TYPES as ICON_TYPES } from '../../icon/constants';
import {
  APPEARANCES as ACTION_BUTTON_APPEARANCES,
  FORMATS as ACTION_BUTTON_FORMATS,
} from '../../action-button/constants';
import { APPEARANCES as PARAGRAPH_APPEARANCES } from '../../paragraph/constants';
import { HEADING_APPEARANCES } from '../../heading/constants';
import { APPEARANCES } from '../constants';

const getAppearanceConfig = (appearance) => {
  switch (appearance) {
    case APPEARANCES.defaultAccent: {
      return {
        iconType: ICON_TYPES.accent,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.accent,
        actionButtonFormat: ACTION_BUTTON_FORMATS.solid,
        headingAppearance: HEADING_APPEARANCES.default,
        paragraphAppearance: PARAGRAPH_APPEARANCES.mediumEmphasis,
      };
    }

    case APPEARANCES.defaultCta: {
      return {
        iconType: ICON_TYPES.cta,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.cta,
        actionButtonFormat: ACTION_BUTTON_FORMATS.solid,
        headingAppearance: HEADING_APPEARANCES.default,
        paragraphAppearance: PARAGRAPH_APPEARANCES.mediumEmphasis,
      };
    }

    case APPEARANCES.accent: {
      return {
        iconType: ICON_TYPES.white,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.accent,
        actionButtonFormat: ACTION_BUTTON_FORMATS.solidWhite,
        headingAppearance: HEADING_APPEARANCES.white,
        paragraphAppearance: PARAGRAPH_APPEARANCES.white,
      };
    }

    case APPEARANCES.cta: {
      return {
        iconType: ICON_TYPES.white,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.cta,
        actionButtonFormat: ACTION_BUTTON_FORMATS.solidWhite,
        headingAppearance: HEADING_APPEARANCES.white,
        paragraphAppearance: PARAGRAPH_APPEARANCES.white,
      };
    }
  }

  return {
    iconType: ICON_TYPES.default,
    actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
    actionButtonFormat: ACTION_BUTTON_FORMATS.solid,
    headingAppearance: HEADING_APPEARANCES.default,
    paragraphAppearance: PARAGRAPH_APPEARANCES.mediumEmphasis,
  };
};

export default getAppearanceConfig;
